var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFndLogo = function SvgFndLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 98 33",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m64.8935 16.456c0 9.0884-7.3676 16.456-16.456 16.456s-16.456-7.3676-16.456-16.456c0-9.08839 7.3676-16.456 16.456-16.456s16.456 7.36761 16.456 16.456zm-47.9911-14.88859c.3016-.52241 1.0556-.52241 1.3572 0l16.7962 29.09189c.3017.5224-.0754 1.1754-.6786 1.1754h-33.592412c-.603231 0-.980249-.653-.678634-1.1754zm51.7119-.588048c-.8655 0-1.5672.701678-1.5672 1.567238v27.8185c0 .8656.7017 1.5673 1.5672 1.5673h27.8185c.8656 0 1.5673-.7017 1.5673-1.5673v-27.8185c0-.86556-.7017-1.567238-1.5673-1.567238z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgFndLogo;